// components/ui/FormContainer.tsx
import React from "react";

interface FormContainerProps {
  children: React.ReactNode;
}

export const FormContainer: React.FC<FormContainerProps> = ({ children }) => {
  return (
    <div className="bg-gradient-to-br from-blue-50 via-white to-cyan-50 rounded-3xl p-6 sm:p-8 shadow-2xl border border-blue-100 relative overflow-hidden">
      {children}
    </div>
  );
};